// fill="${color ? color : "currentColor"}"
// width=${width}
// height=${height}
// currentColor ใส่เเทนสี ที่ต้องการเปลี่ยน สีตาม  ConfigProvider theme
import PropTypes from 'prop-types'

import React from 'react'

const Index = ({ width = 16, height = 16, color }) => {
  const svgXml = ` <svg
           width=${width}
          height=${height}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 14C3.13438 14 0 10.8656 0 7C0 3.13437 3.13438 0 7 0C10.8656 0 14 3.13437 14 7C14 10.8656 10.8656 14 7 14ZM9.58438 4.34062L8.55313 4.34531L7 6.19687L5.44844 4.34688L4.41563 4.34219C4.34688 4.34219 4.29063 4.39688 4.29063 4.46719C4.29063 4.49688 4.30156 4.525 4.32031 4.54844L6.35313 6.97031L4.32031 9.39062C4.30143 9.41353 4.29096 9.4422 4.29063 9.47188C4.29063 9.54063 4.34688 9.59688 4.41563 9.59688L5.44844 9.59219L7 7.74062L8.55156 9.59062L9.58281 9.59531C9.65156 9.59531 9.70781 9.54063 9.70781 9.47031C9.70781 9.44063 9.69688 9.4125 9.67813 9.38906L7.64844 6.96875L9.67969 4.54688C9.69844 4.52344 9.70938 4.49531 9.70938 4.46562C9.70938 4.39687 9.65313 4.34062 9.58438 4.34062Z"
              fill="${color ? color : 'currentColor'}"
              fillOpacity="0.85"
            />
          </svg>
   `

  return (
    <div
      style={{ display: 'flex', alignItems: 'center' }}
      dangerouslySetInnerHTML={{ __html: svgXml }}
    />
  )
}
Index.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}
export default Index
